"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_VALIDATION = void 0;
exports.EMAIL_VALIDATION = /\S+@\S+\.\S+/;
